import { WriterHeaderProps } from './Types'
import { ArticleView } from 'types'
import { CanView } from 'components/Can'
import { observer } from 'mobx-react-lite'
import { WriterTopBar } from '../WriterTopBar/WriterTopBar'
import { WriterToolbar } from 'components/WriterToolbar/WriterToolbar'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { MobileWriterHeader } from 'blaze-components/WorkspaceDashboardHeader/MobileWriterHeader'
import { Header } from './Header'
import { useIsSystemRedesign } from 'hooks/useIsSystemRedesign'
import cx from 'classnames'
import Styles from './Header.module.scss'

const WriterHeader = observer(({ workspace }: WriterHeaderProps) => {
  const isSystemRedesignEnabled = useIsSystemRedesign()

  return (
    <Header data-testid="writer-header" className={cx({ [Styles.writerHeader]: isSystemRedesignEnabled })}>
      <WriterTopBar />
      <CanView inWorkspace={workspace.id} inViewMode={ArticleView.Editing}>
        <WriterToolbar />
      </CanView>
    </Header>
  )
})

const WriterHeaderContainer = (props: WriterHeaderProps) => {
  const { isMobile } = useResponsiveDesign()

  return isMobile ? <MobileWriterHeader {...props} /> : <WriterHeader {...props} />
}

export { WriterHeaderContainer as WriterHeader }
